import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import { EServices } from "@/types";
import { IVForm } from "@/types";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";

import { emailRule, requiredLengthRule, requiredRule } from "@/utils/rules";
import {
  Component,
  Ref,
  Mixins,
  Inject,
  Watch,
  Prop,
} from "vue-property-decorator";
import AuthClient from "../../services/AuthClient";

@Component
export default class CreateAccount extends Mixins(
  JackocoinsNetworkManagerMixin
) {
  @Inject(EServices.auth)
  authClient!: AuthClient;

  firstName = "";
  lastName = "";
  username = "";
  email = "";
  password = "";
  captchaToken = "";
  referralCode = "";
  referral: string | null = null;

  @Ref()
  createAccountForm!: IVForm;

  get refCode() {
    return this.referral;
  }

  emailRule = emailRule;
  requiredRule = requiredRule;
  requiredLengthRule = requiredLengthRule;
  turnstileContainerId = `turnstile-${Math.random()
    .toString(36)
    .substring(2, 10)}-register`;

  createTurnstileWidget() {
    turnstile.render(`#${this.turnstileContainerId}`, {
      sitekey: "0x4AAAAAACxL73T6KYGIrcnM",
      theme: "light",
      callback: (token: string) => {
        this.captchaToken = token;
      },
    });
  }

  @throwsNetworkError()
  async createAccount() {
    if (!this.createAccountForm.validate()) return;
    console.log("createAccount");
    const response = await this.authClient.register(
      this.firstName,
      this.lastName,
      this.username,
      this.email,
      this.password,
      this.captchaToken
    );
    if (response.status === 201) {
      // await this.authClient.generateReferralCode();
      // await this.authClient.linkReferralToReferrer(
      //   response.data.id,
      //   this.referral || this.referralCode
      // );
    }
    this.$router.replace("/dashboard");
  }

  created() {
    this.referral = this.$route.query.referral as string;
  }

  mounted() {
    this.createTurnstileWidget();
  }
}
